import { render } from "./FleetMaintenance.vue?vue&type=template&id=5d88187c&scoped=true"
import script from "./FleetMaintenance.vue?vue&type=script&lang=js"
export * from "./FleetMaintenance.vue?vue&type=script&lang=js"

import "./FleetMaintenance.vue?vue&type=style&index=0&id=5d88187c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d88187c"]])

export default __exports__